import styled from 'styled-components'

import { COLORS } from 'consts/colors'

export const ProjectNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`

export const ProjectName = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${COLORS.secondarySemiDark};
  padding: 4px 6px;
  border-radius: 4px;
  background: ${COLORS.white};
  max-width: 130px;
  overflow-x: hidden;
  white-space: nowrap;
  cursor: text;

  &:hover,
  &:focus {
    color: ${COLORS.secondarySemiDark};
    background: ${COLORS.primaryLight};
  }

  &:not(:focus) {
    text-overflow: ellipsis;
  }
`
